import { getInteger } from './get-integer'
import { ServerSettingsFormValue } from '.'
import { SingleServerSettings } from '../servers-grid/shared'
import { SAMPLING_OPTIONS } from './server-settings-form-single-view'

export function getSingleServerSettings(
  {
    name,
    logLevel,
    logPath,
    environment,
    stacktraceCaptureMode,
    botProtection,
    samplingEnabled,
    samplingProfile,
    samplingFrequency,
    samplingBaseline,
    samplingWindow,
    syslogEnabled,
    syslog
  }: ServerSettingsFormValue,
  {
    assess,
    protect
  }: {
    readonly assess: boolean
    readonly protect: boolean
  }
): SingleServerSettings {
  return {
    name,
    logPath,
    environment: environment || 'DEVELOPMENT',
    logLevel: logLevel || 'INFO',
    assess: assess
      ? {
          samplingProfile,
          stacktraceCaptureMode: stacktraceCaptureMode || 'ALL',
          sampling:
            samplingEnabled || samplingProfile === SAMPLING_OPTIONS.CUSTOM
              ? {
                  frequency: getInteger(samplingFrequency),
                  baseline: getInteger(samplingBaseline),
                  window: getInteger(samplingWindow)
                }
              : undefined
        }
      : undefined,
    protect: protect
      ? {
          botProtection,
          syslog: syslogEnabled
            ? {
                ipAddress: syslog.host,
                protocol: syslog.protocol,
                port: syslog.port,
                facilityCode: syslog.facilityCode,
                severityExploited: syslog.severityByAttackStatus.EXPLOITED,
                severitySuspicious: syslog.severityByAttackStatus.SUSPICIOUS,
                severityBlocked: syslog.severityByAttackStatus.BLOCKED,
                severityBlockedPerimeter:
                  syslog.severityByAttackStatus.BLOCKED_PERIMETER,
                severityProbed: syslog.severityByAttackStatus.PROBED
              }
            : undefined
        }
      : undefined
  }
}
